<div class="">
  <app-navigation></app-navigation>
  <div class="background-green">
    <div class="fullscreen-background"><router-outlet></router-outlet></div>
  </div>
</div>

<app-footer></app-footer>
